import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:8000";

export const searchCities = async (query, token) => {
  try {
    const { data } = await axios.get(`${API_URL}/api/location/cities`, {
      params: { query },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return { status: "ok", data: data.data || [] };
  } catch (error) {
    console.error("Error searching cities:", error);
    return {
      status: "error",
      message: error.response?.data?.message || "Failed to search cities",
      data: [],
    };
  }
};

// Search for places
export const searchPlaces = async (query, token) => {
  try {
    const { data } = await axios.get(`${API_URL}/api/location/search`, {
      params: { query },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return { status: "ok", data: data.data };
  } catch (error) {
    console.error("Error searching places:", error);
    return { 
      status: "error", 
      message: error.response?.data?.message || "Failed to search places" 
    };
  }
};


// Get nearby places
export const getNearbyPlaces = async (lat, lng, radius = 5000, token) => {
  try {
    const { data } = await axios.get(`${API_URL}/api/location/nearby`, {
      params: { lat, lng, radius },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return { status: "ok", data: data.data };
  } catch (error) {
    console.error("Error getting nearby places:", error);
    return { 
      status: "error", 
      message: error.response?.data?.message || "Failed to get nearby places" 
    };
  }
};

// Save recent location
export const saveRecentLocation = async (location, token) => {
  try {
    const { data } = await axios.post(`${API_URL}/api/location/recent`, 
      { location },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return { status: "ok", data };
  } catch (error) {
    console.error("Error saving recent location:", error);
    return { 
      status: "error", 
      message: error.response?.data?.message || "Failed to save recent location" 
    };
  }
};

// Get current location using browser geolocation and reverse geocoding
export const getCurrentLocation = () => {
  return new Promise((resolve, reject) => {
    if (!navigator.geolocation) {
      reject(new Error("Geolocation is not supported by this browser"));
      return;
    }

    navigator.geolocation.getCurrentPosition(
      async (position) => {
        try {
          // Try to get place name using reverse geocoding
          const address = await reverseGeocode(position.coords.latitude, position.coords.longitude);
          
          const location = {
            id: 'current_location',
            name: 'My Current Location',
            address: address || `${position.coords.latitude.toFixed(6)}, ${position.coords.longitude.toFixed(6)}`,
            lat: position.coords.latitude,
            lng: position.coords.longitude,
            type: 'current',
            accuracy: position.coords.accuracy
          };
          resolve(location);
        } catch (error) {
          // Fallback to coordinates if reverse geocoding fails
          const location = {
            id: 'current_location',
            name: 'My Current Location',
            address: `${position.coords.latitude.toFixed(6)}, ${position.coords.longitude.toFixed(6)}`,
            lat: position.coords.latitude,
            lng: position.coords.longitude,
            type: 'current',
            accuracy: position.coords.accuracy
          };
          resolve(location);
        }
      },
      (error) => {
        reject(error);
      },
      {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 300000 // 5 minutes
      }
    );
  });
};

// Reverse geocoding to get place name from coordinates
const reverseGeocode = async (lat, lng) => {
  try {
    // Using OpenStreetMap Nominatim API (free, no API key required)
    // Request English language for place names
    const response = await fetch(
      `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lng}&zoom=18&addressdetails=1&accept-language=en`
    );
    
    if (!response.ok) {
      throw new Error('Reverse geocoding failed');
    }
    
    const data = await response.json();
    
    if (data.display_name) {
      // Extract a shorter, more readable address in English
      const addressParts = data.display_name.split(', ');
      const shortAddress = addressParts.slice(0, 3).join(', '); // Take first 3 parts
      return shortAddress;
    }
    
    return null;
  } catch (error) {
    console.error('Reverse geocoding error:', error);
    return null;
  }
}; 